import { useLocation } from 'react-router-dom';

export function useQueryParams<T extends Record<string, string>>() {
  const { search } = useLocation();
  const params = new URLSearchParams(search);

  const getParam = <K extends keyof T>(key: K): T[K] | null => {
    return params.get(key as string) as T[K] | null;
  };

  const getAllParams = (): Partial<T> => {
    return Object.fromEntries(params.entries()) as Partial<T>;
  };

  return { getParam, getAllParams };
}
